<template>
  <b-container fluid class="footer" id="footer">
    <b-container>
      <b-row>
        <b-col md="3">
          <router-link to="/">
            <img src="../assets/puuinfo-logo-iso.png" alt="" class="logo">
          </router-link>
        </b-col>
        <b-col md="3">
          <p><a href="mailto:info@puuinfo.fi">info@puuinfo.fi</a></p>
        </b-col>
        <b-col md="3">
          <p><strong><router-link to="/kayttoohje">Käyttöohjeet</router-link></strong></p>
          <p><strong><router-link to="/maaritelmia">Määritelmiä</router-link></strong></p>
          <p><strong><router-link to="/hyodyllisia-linkkeja/">Hyödyllisiä linkkejä</router-link></strong></p>
        </b-col>
        <b-col md="3">
          <p><strong><router-link to="/kayttoehdot">Käyttöehdot</router-link></strong></p>
          <p><strong><router-link to="/tietosuojakaytanto">Tietosuojakäytäntö</router-link></strong></p>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col md="12" class="text-center">
          <p>Tämän palvelun tekemistä ovat rahoittaneet:</p>
        </b-col>
        <b-col md="12" class="text-center">
          <a href="https://www.metsasaatio.fi/" target="_blank"><img src="../assets/metsasaatio.png" alt="Suomen Metsäsäätiö" class="logo-sponsor logo-square"></a>
          <a href="https://www.kollinsaatio.com/" target="_blank"><img src="../assets/kollin-saatio.png" alt="Marjatta- ja Eino Kollin säätiö" class="logo-sponsor logo-square"></a>
          <a href="https://rtl-saatio.fi/" target="_blank"><img src="../assets/Rakennustuotteiden-laatu.png" alt="Rakennustuotteiden Laatu Säätiö" class="logo-sponsor"></a>
          <a href="https://www.ym.fi/fi-FI" target="_blank"><img src="../assets/Ymparistoministerio.png" alt="Ympäristöministeriö" class="logo-sponsor"></a>
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>

export default {
  name: 'Footer',
  data () {
    return {}
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .footer {
    background-color: #0F3332;
    text-align: left;
    padding: 5rem 15px;
    color: white;
  }
  .footer a{
    color: white;
    text-decoration: underline;
  }
  .logo {
    width: 160px;
    height: auto;
    margin-bottom: 3rem;
  }
  .logo-sponsor {
    max-width: 160px;
    margin: 0 1rem 2rem 1rem;
  }
  .logo-square {
    height: 70px;
  }

  @media (min-width: 1200px){
    /*
    .logo-sponsor {
      max-width: 240px;
      margin: 0 3rem;
    }
    */
  }

  @media print {
    .footer {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue